export const mainCaroseldata = [
    {
        image : "https://sslimages.shoppersstop.com/sys-master/root/h64/h70/32117147140126/ss-web_270224d.jpg"
    },

    {
        image : "https://sslimages.shoppersstop.com/sys-master/root/h1e/h41/32004481253406/Louis-Philippe-%26-Van-Heusen-web_89.jpg"
    },
    {
        image: "//assets.tatacliq.com/medias/sys_master/images/50504080326686.jpg"
    },
    {
        image: "https://assets.ajio.com/cms/AJIO/WEB/D-1.0-UHP-26032024-MainBannerDailyChanging-Z1-P3-Fusion-VeroModa-MIN60.jpg"
    },

    {
        image: "/Images/62041480593438.avif"
    },
    {
        image: "/Images/62041480658974.avif"
    },
    {
        image: "/Images/62041480855582.avif"
    },



    // {
    //     image: "https://www.lee.in/media/mageplaza/bannerslider/banner/image/2/3/23-490_lee_sara_cover_v3_1440x423_11zon.jpg"
    // },

    // {
    //     image: "https://www.lee.in/media/mageplaza/bannerslider/banner/image/s/p/spring_summer_collection24_desktop_banner_-_1400x423_1.jpg"
    // },

    // {
    //     image: "https://www.lee.in/media/mageplaza/bannerslider/banner/image/u/j/uj-website-banner.jpg"
    // },

    // {
    //     image: "//assets.tatacliq.com/medias/sys_master/images/50504080523294.jpg"
    // },

    // {
    //     image: "//assets.tatacliq.com/medias/sys_master/images/50504080392222.jpg"
    // },


    // {
    //     image: "//assets.tatacliq.com/medias/sys_master/images/50504080523294.jpg"
    // },

    // {
    //     image: "//assets.tatacliq.com/medias/sys_master/images/50504080883742.jpg"
    // },
      

    
    
] 